(function () {
  'use strict';
  if (!document.body.classList.contains('hlx-native') || window.HLXPDPParity) return;
  window.HLXPDPParity = true;
  const mounted = new WeakSet();

  function gallery(root) {
    if (mounted.has(root)) return;
    mounted.add(root);
    const thumbnails = Array.from(root.querySelectorAll('[data-hlx-image-index]'));
    const image = root.querySelector('.hlx-pdp-image');
    const count = root.querySelector('[data-hlx-image-count]');
    const zoom = root.querySelector('[data-hlx-zoom]');
    const dialog = root.querySelector('[data-hlx-lightbox]');
    if (!dialog || !thumbnails.length || !image || !zoom || !count) return;
    const enlarged = dialog.querySelector('.hlx-pdp-lightbox-image');
    const close = dialog.querySelector('[data-hlx-close-image]');
    let current = 0;
    if (!enlarged || !close) return;
    const arrowStep = key => (key === 'ArrowRight' ? 1 : -1) * (getComputedStyle(root).direction === 'rtl' ? -1 : 1);
    function select(index) {
      current = (index + thumbnails.length) % thumbnails.length;
      image.src = thumbnails[current].dataset.hlxImageUrl;
      image.removeAttribute('srcset');
      enlarged.src = image.src;
      enlarged.removeAttribute('srcset');
      count.textContent = `${current + 1} / ${thumbnails.length}`;
      thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
    }
    thumbnails.forEach((button, index) => {
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbnails.length - 1
          : current + arrowStep(event.key);
        select(next);
        thumbnails[current].focus();
      });
    });
    zoom.addEventListener('click', () => {
      enlarged.src = image.currentSrc || image.src;
      dialog.showModal();
      document.body.classList.add('hlx-image-open');
      close.focus();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.body.classList.remove('hlx-image-open');
      zoom.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      select(current + arrowStep(event.key));
    });
    dialog.querySelectorAll('[data-hlx-image-step]').forEach(button => {
      button.hidden = thumbnails.length < 2;
      button.addEventListener('click', () => select(current + Number(button.dataset.hlxImageStep)));
    });
  }

  function accessibleDisclosures(scope) {
    scope.querySelectorAll('.faq__content--header, .rightBox .details').forEach((control, index) => {
      if (mounted.has(control)) return;
      mounted.add(control);
      const panel = control.nextElementSibling;
      if (!panel) return;
      const opened = () => !panel.classList.contains('faq__content--panel-hidden') && getComputedStyle(panel).display !== 'none';
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      if (!panel.id) panel.id = `hlx-pdp-disclosure-${index}`;
      control.setAttribute('aria-controls', panel.id);
      control.setAttribute('aria-expanded', String(opened()));
      control.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        control.click();
      });
      control.addEventListener('click', () => requestAnimationFrame(() => {
        control.setAttribute('aria-expanded', String(opened()));
      }));
    });
  }

  function mount(scope) {
    scope.querySelectorAll('[data-hlx-pdp-gallery]').forEach(gallery);
    accessibleDisclosures(scope);
    scope.querySelectorAll('#footer-product-form .buy-button').forEach(button => {
      if (button.querySelector('.hlx-pdp-bag')) return;
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('class', 'hlx-pdp-bag');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const path = document.createElementNS(ns, 'path');
      path.setAttribute('d', 'M5.3 7.5h13.4l1 12a1.8 1.8 0 0 1-1.8 2H6.1a1.8 1.8 0 0 1-1.8-2z M8.5 8V6a3.5 3.5 0 0 1 7 0v2');
      svg.appendChild(path);
      button.prepend(svg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
